/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Lexique_Unclog_Check_Radio_TransmissionInputs */



/**
* | output |
* | --- |
* | "Unclog head / check radio transmission" |
*
* @param {Intervention_Plan_Pdf_Lexique_Unclog_Check_Radio_TransmissionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_lexique_unclog_check_radio_transmission = /** @type {((inputs?: Intervention_Plan_Pdf_Lexique_Unclog_Check_Radio_TransmissionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Lexique_Unclog_Check_Radio_TransmissionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Unclog head / check radio transmission")
	return /** @type {LocalizedString} */ ("Désencombrer la tête/Vérifier la transmission radio")
});